import React, { useState, useRef } from "react";
import ReCAPTCHA from 'react-google-recaptcha';

const Contacto = () => {
  const recaptchaRef = useRef(null); // Usamos la referencia aquí
  const seccionRef = useRef(null);

  const manejarClick = () => {
    seccionRef.current?.focus()
  };

  const [nombre, setNombre] = useState("");
  const [correo, setCorreo] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [number, setNumber] = useState("");
  const [respuesta, setRespuesta] = useState(null); // Estado para el mensaje de respuesta
  const [isLoading, setIsLoading] = useState(false);
  const [captchaResponse, setCaptchaResponse] = useState(null);

  const handleCaptchaChange = (value) => {
    setCaptchaResponse(value);
  };

  const manejarEnvio = async (e) => {
    e.preventDefault();

    
    try {
      setIsLoading(true);
      const respuesta = await fetch(
        "https://disomex.onrender.com/api/enviar-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            nombre,
            correo,
            number,
            mensaje,
            'g-recaptcha-response': captchaResponse,
          }), // Datos a enviar
        }
      );

      if (respuesta.ok) {
        const data = await respuesta.json();
        setIsLoading(false);
        setRespuesta({
          exito: true,
          mensaje: data.mensaje || "Correo enviado con éxito",
        });
        
        // Limpiar los campos del formulario
        setNombre("");
        setCorreo("");
        setMensaje("");
        setNumber("");
        setCaptchaResponse(null);

        // Limpiar el CAPTCHA
        recaptchaRef.current.reset(); // Llamar al reset de reCAPTCHA
      } else {
        const errorData = await respuesta.json();
        setIsLoading(false);
        setRespuesta({
          exito: false,
          mensaje: errorData.mensaje || "Error al enviar el correo",
        });

        // Limpiar los campos del formulario en caso de error
        setNombre("");
        setCorreo("");
        setMensaje("");
        setNumber("");
        setCaptchaResponse(null);

        // Limpiar el CAPTCHA también en caso de error
        recaptchaRef.current.reset(); // Llamar al reset de reCAPTCHA
      }
    } catch (error) {
      setIsLoading(false);
      setRespuesta({
        exito: false,
        mensaje: "Ocurrió un error al enviar el correo",
      });
      console.error("Error al enviar el formulario:", error);
    }

    setTimeout(() => {
      setRespuesta(null);
    }, 3000);
  };

  return (
    <div className="">
      {respuesta && (
        <div
          className={`fixed top-20 left-0 right-0 flex justify-center items-center m-auto w-[70%] h-[10%] mt-4 p-2 rounded-xl ${
            respuesta.exito ? "bg-green-600" : "bg-red-600"
          } text-white text-center text-xl`}
        >
          <p className="font-semibold">{respuesta.mensaje}</p>
        </div>
      )}

      <div className="flex flex-col justify-around p-6 sm:flex-row">
        <div className="mb-6 flex flex-col items-center justify-center bg-[#1a354b] text-white p-6 rounded-2xl shadow-lg text-center sm:w-[40%]">
          <h2 className="text-2xl font-bold mb-4">¡Recibe Nuestra Asesoría!</h2>
          <p className="text-lg mb-6">
            Nuestro equipo de expertos está listo para ayudarte a transformar
            tus ideas en realidad.
          </p>
          <button onClick={manejarClick}
            className="bg-[#e9aa0d] text-white font-bold py-2 px-4 rounded hover:bg-orange-600 transition duration-300"
          >
            Contáctanos Ahora
          </button>
        </div>

        <div className="mb-6 bg-[#1a354b] w-[100%] text-white p-4 py-10 rounded-2xl shadow-lg sm:w-[40%]">
          <form
            className="flex items-center flex-col gap-4"
            onSubmit={manejarEnvio}
          >
            <h1 className="text-3xl font-semibold text-center mb-2">Contacto</h1>
            <input ref={seccionRef}
              id="nombre"
              className="p-2 w-full bg-[#335571] text-white rounded-md outline-none focus:ring-2 focus:ring-[#e9aa0d]"
              type="text"
              placeholder="Nombre"
              required
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
            />
            <input
              className="p-2 w-full bg-[#335571] text-white rounded-md outline-none focus:ring-2 focus:ring-[#e9aa0d]"
              type="email"
              placeholder="Correo"
              required
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
            />
            <input
              className="p-2 w-full bg-[#335571] text-white rounded-md outline-none focus:ring-2 focus:ring-[#e9aa0d]"
              type="tel"
              placeholder="Número de Cel."
              required
              value={number}
              onChange={(e) => {
                const onlyNums = e.target.value.replace(/\D/g, ""); // Eliminar caracteres no numéricos
                setNumber(onlyNums);
              }}
            />
            <textarea
              className="p-2 w-full bg-[#335571] text-white rounded-md outline-none focus:ring-2 focus:ring-[#e9aa0d]"
              placeholder="Mensaje"
              rows="4"
              required
              value={mensaje}
              onChange={(e) => setMensaje(e.target.value)}
            ></textarea>

            <div>
              <ReCAPTCHA
                sitekey="6LebMGwqAAAAAOQzxBzWbDiEmwjGmYhUXjTFpWO6"
                onChange={handleCaptchaChange}
                ref={recaptchaRef} // Pasa la referencia aquí
              />
            </div>

            <button
              type="submit"
              className="bg-[#e9aa0d] w-full text-white py-2 rounded-md hover:bg-orange-600 transition-all duration-300"
            >
              Enviar
            </button>
            {isLoading && (
              <div className="text-xl font-semibold text-center text-white flex items-center">
                Enviando
                <span className="dot-1 animate-bounce">.</span>
                <span className="dot-2 animate-bounce200">.</span>
                <span className="dot-3 animate-bounce400">.</span>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contacto;
